import React from 'react'
import UserLogin from '../../Components/client/Login'

function Login() {
  return (
    <div>
      <UserLogin/>
    </div>
  )
}

export default Login
